import { fetchClient } from "@/lib/fetchClient";
import type { MutationConfig } from "@/lib/react-query";
import { queryClient } from "@/lib/react-query";
import type { GetFolderResponse } from "@/types/resources";
import { isObject } from "@/utils/typeGuard";
import { useMutation } from "react-query";

async function deleteWorkflow(workflow_id: string) {
  return await fetchClient.DELETE("/workflows/{workflow_id}", {
    params: { path: { workflow_id } },
  });
}

type UseDeleteWorkflowOptions = {
  config?: MutationConfig<typeof deleteWorkflow>;
};

export const useDeleteWorkflow = ({
  config,
}: UseDeleteWorkflowOptions = {}) => {
  return useMutation({
    mutationFn: deleteWorkflow,
    onMutate: async (workflowId) => {
      await queryClient.cancelQueries("folders");

      const previousData =
        queryClient.getQueryData<GetFolderResponse>("folders");

      if (previousData) {
        const newData = {
          folders: previousData.folders.map((folder) => ({
            ...folder,
            workflows: folder.workflows.filter((w) => w.id !== workflowId),
          })),
          unassigned_workflows: previousData.unassigned_workflows.filter(
            (w) => w.id !== workflowId
          ),
        };
        queryClient.setQueryData("folders", newData);
      }

      return { previousData };
    },
    onError: (_, __, context: unknown) => {
      if (isObject(context) && "previousData" in context) {
        queryClient.setQueryData("folders", context["previousData"]);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries("folders");
    },
    ...config,
  });
};
